(() => {
  const selector = '[data-zyra-motion]';
  const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      entry.target.classList.remove('zyra-motion-pending');
      entry.target.classList.add('zyra-motion-visible');
      observer.unobserve(entry.target);
    });
  }, {
    root: null,
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.06
  });

  const prepare = (root) => {
    const elements = [];

    if (root instanceof Element && root.matches(selector)) {
      elements.push(root);
    }

    if (root && typeof root.querySelectorAll === 'function') {
      elements.push(...root.querySelectorAll(selector));
    }

    elements.forEach((element) => {
      if (element.dataset.zyraMotionBound === 'true') return;
      element.dataset.zyraMotionBound = 'true';

      const bounds = element.getBoundingClientRect();
      if (bounds.top <= window.innerHeight * 0.94) {
        element.classList.add('zyra-motion-visible');
        return;
      }

      element.classList.add('zyra-motion-pending');
      observer.observe(element);
    });
  };

  const start = () => prepare(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    prepare(event.target);
  });

  document.addEventListener('focusin', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const pending = target.closest('[data-zyra-motion].zyra-motion-pending');
    if (!pending) return;

    pending.classList.remove('zyra-motion-pending');
    pending.classList.add('zyra-motion-visible');
    observer.unobserve(pending);
  });
})();